
/*********************************************************************
 *
 * WARNING: This shader class is automatically generated, any manual
 * edits will be lost.
 *
 ********************************************************************/
import { ShaderBase, ShaderUniformsContainer, ShaderAttributesContainer } from '../shader';
import { Texture, CubeMapTexture } from '../../texture';
import { Context } from '../../context/Context';
import { mat3, mat4, vec2, vec3, vec4 } from "gl-matrix";
import { ShaderSourceParser } from '../shader-source-parser';

export type GodRaysOcclusionShaderUniforms = {
	uDepthMap: WebGLUniformLocation,
	uSunColor: WebGLUniformLocation
};

export type GodRaysOcclusionShaderAttributes = {
	aVertexPosition: number,
	vTexCoord: number
};

export type GodRaysOcclusionShaderSettings = string[];

export class GodRaysOcclusionShader extends ShaderBase<GodRaysOcclusionShaderUniforms, GodRaysOcclusionShaderAttributes> {

    private static fragmentShaderSource = `
in vec2 vTexCoord;
out vec4 fragColor;

uniform sampler2D uDepthMap;
uniform vec3 uSunColor;

void main(void) {
	// If no geometry at this pixel, it's open sky -> sun light visible.
	// Cleared depth = 1.0 means "no opaque surface drawn".
	float depth = texture(uDepthMap, vTexCoord).r;

	if (depth >= 1.0) {
		fragColor = vec4(uSunColor, 1.0);
	} else {
		fragColor = vec4(0.0, 0.0, 0.0, 1.0);
	}
}
`;

    private static vertexShaderSource = `
// --- begin: fullscreen_quad.vert.glsl ---
layout(location = 0) in vec2 aVertexPosition;
out vec2 vTexCoord;

void main(void) {
	vTexCoord = aVertexPosition * 0.5 + 0.5;
	gl_Position = vec4(aVertexPosition, 0.0, 1.0);
}
// --- end: fullscreen_quad.vert.glsl ---
`;

    public override get version(): string {
        return '300 es';
    }

    public override get parser(): any {
        return new ShaderSourceParser();
    }

    protected override get warnAttributeMismatch(): boolean {
        return false;
    }

    public uniformsContainer: GodRaysOcclusionShaderUniformsContainer;
    public attributesContainer: GodRaysOcclusionShaderShaderAttributesContainer;

    constructor(ctx: Context, settings: GodRaysOcclusionShaderSettings) {
        super(ctx, GodRaysOcclusionShader.fragmentShaderSource, GodRaysOcclusionShader.vertexShaderSource, settings);
        this.uniformsContainer = new GodRaysOcclusionShaderUniformsContainer(ctx, this);
        this.attributesContainer = new GodRaysOcclusionShaderShaderAttributesContainer(ctx, this);
    }
}

class GodRaysOcclusionShaderUniformsContainer extends ShaderUniformsContainer {
    constructor(ctx: Context, private shader: GodRaysOcclusionShader) {
        super(ctx);
    }

    public setDepthMap(texture: Texture) : GodRaysOcclusionShaderUniformsContainer {
        this.setTextureValue('uDepthMap', this.shader.uniforms.uDepthMap, texture, 'sampler2D');
        return this;
    }

    public setSunColor(value: vec3 | number[]) : GodRaysOcclusionShaderUniformsContainer {
        this.setValue('uSunColor', this.shader.uniforms.uSunColor, value, 'vec3');
        return this;
    }

    protected getTextureUniforms() {
        return [
			{ name: 'uDepthMap', uniform: this.shader.uniforms.uDepthMap, dataType: 'sampler2D' }
        ];
    }
}

class GodRaysOcclusionShaderShaderAttributesContainer extends ShaderAttributesContainer {
    constructor(ctx: Context, private shader: GodRaysOcclusionShader) {
        super(ctx);
    }

    public setVertexPosition(settings: { length: number, offset: number, itemSize: number }) : GodRaysOcclusionShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.aVertexPosition, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }

    public setvTexCoord(settings: { length: number, offset: number, itemSize: number }) : GodRaysOcclusionShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.vTexCoord, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }
}